<template>
  <div>
    <div class="sectionOuterBox bgBlue cWhite hero">
      <div class="sectionInnerBox textCenter py50">
        <div class="container">
          <div class="text36 fontWeightBold">
            {{ $t('about.team.hero.title') }}
          </div>
        </div>
      </div>
    </div>
    <div class="sectionOuterBox">
      <div class="sectionInnerBox">
        <div class="container sectionContainer">
          <div class="team-grid">
            <EmployeeCard
              v-for="(member, index) in $t('about.team.members')"
              :key="index"
              class="team-card"
              :dimension="300"
              :name="member.name"
              :title="member.title"
              :image="member.image"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EmployeeCard from '@/components/core/EmployeeCard.vue';
import { Component, Vue } from 'vue-property-decorator';

@Component({
  components: {
    EmployeeCard
  }
})
export default class Team extends Vue {
}
</script>

<style lang="scss" scoped>
.team-grid {
  display: grid;
  grid-template-columns: auto auto auto;
  grid-template-rows: auto auto;
  gap: 2rem;
  justify-content: center;
  max-width: 1200px;
  margin: 0 auto;
}

.team-card {
  justify-self: center;
  max-width: 300px;
}

.team-card:nth-child(1) { grid-column: 1; grid-row: 1; }
.team-card:nth-child(2) { grid-column: 2; grid-row: 1; }
.team-card:nth-child(3) { grid-column: 3; grid-row: 1; }
.team-card:nth-child(4) { grid-column: 1 / span 2; grid-row: 2; }
.team-card:nth-child(5) { grid-column: 2 / span 2; grid-row: 2; }

@media screen and (max-width: 1000px) {
  .team-grid {
    grid-template-columns: repeat(2, 300px);
    grid-template-rows: auto auto auto;
    gap: 1.5rem;
  }

  .team-card:nth-child(1) { grid-column: 1; grid-row: 1; }
  .team-card:nth-child(2) { grid-column: 2; grid-row: 1; }
  .team-card:nth-child(3) { grid-column: 1; grid-row: 2; }
  .team-card:nth-child(4) { grid-column: 2; grid-row: 2; }
  .team-card:nth-child(5) { grid-column: 1 / 3; grid-row: 3; }
}

@media screen and (max-width: 760px) {
  .team-grid {
    grid-template-columns: 300px;
    grid-template-rows: repeat(5, auto);
    gap: 1rem;
  }

  .team-card:nth-child(1) { grid-column: 1; grid-row: 1; }
  .team-card:nth-child(2) { grid-column: 1; grid-row: 2; }
  .team-card:nth-child(3) { grid-column: 1; grid-row: 3; }
  .team-card:nth-child(4) { grid-column: 1; grid-row: 4; }
  .team-card:nth-child(5) { grid-column: 1; grid-row: 5; }
}
</style>
